import {
    HIDE_INCOMPLETE_PLANTS_MODAL,
    HIDE_UST_MODAL,
    SHOW_INCOMPLETE_PLANTS_MODAL,
    SHOW_UST_MODAL,
    UPDATE_MODAL_DATA,
} from '../constants/actions';
import { dispatch } from '../utils/generalUtils';

export function showPlantListModal(id: string, data, listTitle: string, formType: string) {
    return dispatch({
        type: SHOW_INCOMPLETE_PLANTS_MODAL,
        id,
        data,
        listTitle,
        formType
    });
}

export function hidePlantListModal(id?: string) {
    return dispatch({
        type: HIDE_INCOMPLETE_PLANTS_MODAL,
        id
    });
}

export function hideUSTModal() {
    return dispatch({
        type: HIDE_UST_MODAL,
    });
}

export function showUSTModal(formType, instance, selectedDate) {
    return dispatch({
        type: SHOW_UST_MODAL,
        formType,
        instance,
        selectedDate
    });
}

export function updateModalData(data) {
    return dispatch({
        type: UPDATE_MODAL_DATA,
        data
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/modalActions.ts